import { hostApi } from "@/apis/index";
import Vue from 'vue';

const api_nice = `${hostApi}/api/nice`;

function getNiceEncodeData()
{
    return Vue.prototype.$http.get(`${api_nice}/getEncodeData`);
}

function getNiceEncodeDataByJoin()
{
    return Vue.prototype.$http.get(`${api_nice}/join`);
}

function getNiceEncodeDataByPw()
{
    return Vue.prototype.$http.get(`${api_nice}/passwordChange`);
}

function getNiceEncodeDataByPhone()
{
    return Vue.prototype.$http.get(`${api_nice}/phoneChange`);
}

export {
    getNiceEncodeData,
    getNiceEncodeDataByJoin,
    getNiceEncodeDataByPw,
    getNiceEncodeDataByPhone,
};
